import React from "react";
import { useAuth } from "@/lib/auth";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ScrollText, Clock } from "lucide-react";

export default function PendingApproval() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex flex-col items-center justify-center px-6">
      <div className="flex items-center gap-3 mb-10">
        <ScrollText className="w-5 h-5 text-[#D4AF37]" strokeWidth={1.5} />
        <span className="font-serif text-xl tracking-tight">Ledger</span>
      </div>

      <div className="max-w-md w-full text-center">
        <Clock className="w-10 h-10 text-neutral-500 mx-auto mb-6" strokeWidth={1.2} />
        <h1 className="font-serif text-3xl mb-4">Awaiting approval</h1>
        <p className="text-neutral-400 leading-relaxed mb-2">
          Your account (<span className="text-white">{user?.email}</span>) has been created, but an admin needs to approve it before you can access the workspace.
        </p>
        <p className="text-neutral-500 text-sm mb-10">
          Check back shortly, or reach out to whoever invited you.
        </p>
        <Button
          onClick={handleLogout}
          className="rounded-none bg-white/10 hover:bg-white/20 text-white font-sans text-sm px-6 py-5"
        >
          Sign out
        </Button>
      </div>
    </div>
  );
}
